/**
     * MissionCreated.contract.ts — Event Contract System™ (generation v1).
     * Reserved: a mission was created. Publisher lands with the future v2 Mission Engine sprint (mission stack is legacy today).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const MissionCreatedContract: EventContract = {
      name: 'MissionCreated',
      version: 1,
      description: "Reserved: a mission was created. Publisher lands with the future v2 Mission Engine sprint (mission stack is legacy today).",
      publishers: [],
      subscribers: [],
      fields: [
        { name: 'missionId', type: 'string', required: true, description: "Identifier of the created mission" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Publish time (Date.now()) when the mission record is persisted.",
      stability: 'reserved',
      deprecated: false,
      example: null,
    };
    